import { setVerifiedPrimaryUserId, setError, setNeedToLogin, setLoading } from './slice';
import { verifyUser } from 'services/user';

export const getUserPartnerVerification = (connectRequestId) => async (dispatch, getStore) => {
  dispatch(setLoading(true));
  try {
    const response = await verifyUser(connectRequestId);
    const { user } = getStore();

    if (response?.data?.primaryUserId) {
      dispatch(setVerifiedPrimaryUserId(response.data.primaryUserId));
    }

    // found user and primary user id matches
    if (user && response?.data?.primaryUserId === user?.primaryUserId) {
      dispatch(setNeedToLogin(false));
      dispatch(setLoading(false));
      return;
    }

    // no user found or user is found but primary user id does not match
    dispatch(setNeedToLogin(true));
    dispatch(setLoading(false));
  } catch (error) {
    dispatch(setError(error?.message || 'Partner verification failed'));
    dispatch(setLoading(false));
  }
};
